import { render, staticRenderFns } from "./workaction.vue?vue&type=template&id=480177e7&"
import script from "./workaction.vue?vue&type=script&lang=js&"
export * from "./workaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports